import Vue from 'vue'
import Router from 'vue-router'
import Tournament from './views/Tournament.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/webview/tournament/:id',
      props: true,
      component: Tournament
    }
  ]
})
